import { HStack, Text, VStack } from '@ayble-health/dashboard-components';
import { Textarea } from '@chakra-ui/react';

type Props = {
  editable?: boolean;
  instructions: string;
  onChange: (val: string) => void;
};

export const BlockInstructionsEditor = ({
  editable = true,
  onChange,
  instructions,
}: Props) => {
  return (
    <VStack>
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        <Text color={'secondary.500'} fontSize={'lg'} fontWeight={'medium'}>
          Instructions
        </Text>
        <Text color={'blueGray.600'} fontSize={'xs'}>
          {instructions.length}/500
        </Text>
      </HStack>

      <Textarea
        value={instructions}
        placeholder={'Add patient instructions'}
        onChange={(e) => onChange(e.target.value)}
        disabled={!editable}
        maxLength={500}
        resize={'none'}
        color={'seafoam'}
        borderColor={'cloud.200'}
        h={'120px'}
        rounded={'md'}
      />
    </VStack>
  );
};

export default BlockInstructionsEditor;
